// extracted by mini-css-extract-plugin
export default {"errorPanel":"Pczu-","twitterLinks":"_1VA8w _1brkc","errorCode":"_7RTA9","twitters":"_198gE"};